import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../utils/api.types";
import {
  fetchInventorySummary,
  fetchStockByLocation,
  fetchLowStockItems,
  fetchTopMovingProducts,
  fetchDeadStock,
  fetchTopStockItems,
} from "./inventoryDashboardThunk";

interface InventorySummary {
  totalItems: number;
  totalLocations: number;
  pendingGRNs: number;
  inTransitTransfers: number;
  pendingRequisitions: number;
  totalStockQty: number;
  outOfStockCount: number;
  lowStockCount: number;
  expiringBatchCount: number;
  // Base-unit flow totals + movement counts over the last 30 days.
  stockIn30d: number;
  stockOut30d: number;
  stockInCount30d: number;
  stockOutCount30d: number;
}

interface InventoryDashboardSliceState {
  summary: InventorySummary;
  byLocation: any[];
  lowStock: any[];
  topProducts: any[];
  deadStock: any[];
  topStock: any[];
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: InventoryDashboardSliceState = {
  summary: {
    totalItems: 0,
    totalLocations: 0,
    pendingGRNs: 0,
    inTransitTransfers: 0,
    pendingRequisitions: 0,
    totalStockQty: 0,
    outOfStockCount: 0,
    lowStockCount: 0,
    expiringBatchCount: 0,
    stockIn30d: 0,
    stockOut30d: 0,
    stockInCount30d: 0,
    stockOutCount30d: 0,
  },
  byLocation: [],
  lowStock: [],
  topProducts: [],
  deadStock: [],
  topStock: [],
  status: ApiStatus.IDLE,
  errorMessage: "",
};

const inventoryDashboardSlice = createSlice({
  name: "inventoryDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventorySummary.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(fetchInventorySummary.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.summary = action.payload || initialState.summary;
        state.errorMessage = "";
      })
      .addCase(fetchInventorySummary.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
      })

      .addCase(fetchStockByLocation.fulfilled, (state, action: any) => {
        state.byLocation = action.payload || [];
      })

      .addCase(fetchLowStockItems.fulfilled, (state, action: any) => {
        state.lowStock = action.payload || [];
      })

      .addCase(fetchTopMovingProducts.fulfilled, (state, action: any) => {
        state.topProducts = action.payload || [];
      })

      .addCase(fetchDeadStock.fulfilled, (state, action: any) => {
        state.deadStock = action.payload || [];
      })

      .addCase(fetchTopStockItems.fulfilled, (state, action: any) => {
        state.topStock = action.payload || [];
      });
  },
});

export default inventoryDashboardSlice.reducer;
